export default "__VITE_ASSET__f0109213__"